module.exports = __webpack_public_path__ + "static/media/cq_cerca b.ac92046d.svg";